import z from "zod";

export const ALERT_DIALOG_VARIANTS = ["neutral", "destructive"] as const;

export const alertDialogDataSchema = z.object({
  defaultOpen: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false")
    .describe(
      "Initial open state. Read once, at mount — use `open` instead to change it after the initial render.",
    ),
  open: z
    .string()
    .optional()
    .transform((value) => (value === undefined ? undefined : value !== "false"))
    .describe(
      "Current open state. Settable at any time — e.g. `el.setAttribute('open', '')` or `el.open()` — to open/close the dialog externally.",
    ),
  title: z.string().describe("Alert dialog title."),
  description: z.string().optional().describe("Alert dialog body text."),
  cancelLabel: z.string().describe("Label for the cancel button."),
  actionLabel: z.string().describe("Label for the confirm button."),
  variant: z
    .enum(ALERT_DIALOG_VARIANTS)
    .default("neutral")
    .describe(
      'Visual style of the confirm button — "destructive" for irreversible actions.',
    ),
  onOpenChange: z
    .custom<(open: boolean) => void>()
    .optional()
    .describe(
      "Internal callback bound by readAlertDialogSlotted — not a Twig-authored attribute, passed through the same raw-props pipeline.",
    ),
  onConfirm: z
    .custom<() => void>()
    .optional()
    .describe(
      "Internal callback bound by readAlertDialogSlotted — not a Twig-authored attribute, passed through the same raw-props pipeline.",
    ),
  onCancel: z
    .custom<() => void>()
    .optional()
    .describe(
      "Internal callback bound by readAlertDialogSlotted — not a Twig-authored attribute, passed through the same raw-props pipeline.",
    ),
});

export type AlertDialogDataProps = z.infer<typeof alertDialogDataSchema>;
